import { Switch } from '@thanx/uikit/switch'
import { Text } from '@thanx/uikit/text'
import { pointsApi } from 'api/points'
import Pagination from 'components/Pagination'
import Spinner from 'components/Spinner'
import { buildTranslate } from 'locales'
import { Fields as UserProfile } from 'models/UserProfile'
import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { selectExperience } from 'selectors/pointsExperience'
import Table from './Table'

const t = buildTranslate('users.view.activity.points_expiration')

type PropsT = {
  profile: UserProfile
}

const PointsExpiration: React.FC<PropsT> = ({ profile }: PropsT) => {
  const [currentPage, setCurrentPage] = useState(1)
  const pointsExperience = useSelector(selectExperience)
  const currencyName = pointsExperience?.currency_name_plural || 'points'

  const { data, isLoading, isFetching } =
    pointsApi.useGetPointsExpirationsQuery({
      userIdentifier: profile.uid,
      page: currentPage,
      per_page: 10,
    })

  const handlePageChange = (page: number) => {
    setCurrentPage(page)
    window.scrollTo(0, 0)
  }

  const numPages = data?.pagination?.total_pages ?? 1

  return (
    <div>
      <div className="d-flex justify-content-between">
        <Text.Header4 className={'mb-m'}>{t('title')}</Text.Header4>
      </div>
      <Spinner
        className="d-flex justify-content-center"
        size="3x"
        isLoading={isLoading || isFetching}
      >
        <Switch
          condition={!!(data && data.expirations.length > 0)}
          fallback={
            <Text.BodyText3 color="grey70">{t('empty_state')}</Text.BodyText3>
          }
        >
          <Table
            expirations={data?.expirations || []}
            currencyName={currencyName}
            userIdentifier={profile.uid}
          />
          <div className={'d-flex justify-content-center margin-top-huge'}>
            <Pagination
              currentPage={currentPage}
              onChangePage={handlePageChange}
              numPages={numPages}
            />
          </div>
        </Switch>
      </Spinner>
    </div>
  )
}

export default PointsExpiration
